<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Prekovremeni rad</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Sektor -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label no-print">Sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="seletedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>

    <!-- Prosjek -->
    <div v-if="seletedDepartment">
      <div>
        <div>
          <p>Prosječan prekovremeni rad po zaposlenom u sektoru</p>
          <span
            ><p class="label">{{ seletedDepartment.name }}</p></span
          >
          <p>ukupno:</p>
          <span
            ><p class="label">{{ average }}h</p></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  getShortTimeFromTicks,
  maskIfEquealsValue,
  getDateFromTicks,
  getLastDateOfMonth,
  shouldEmployeeBeAdded,
} from "../../_helpers/arrangers";
//import //   getDateFromTicks,
//   maskIfEquealsValue,
//   isWorkingDayFromDate,
//"../../_helpers/arrangers";
import { colors } from "../../_helpers/colors";

// const colors = [
//   "#363636",
//   "#046FDB",
//   "#F85252",
//   "#8B54E4",
//   "#F07B3B",
//   "#3ba272",
//   "#c1ffa3",
// ];

export default {
  name: "OvertimeList",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      mnth: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      params: {
        data: [
          [
            "n",
            "Ime i prezime",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "Σ",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 30 },
          { column: 2, width: 40 },
          { column: 3, width: 40 },
          { column: 4, width: 40 },
          { column: 5, width: 40 },
          { column: 6, width: 40 },
          { column: 7, width: 40 },
          { column: 8, width: 40 },
          { column: 9, width: 40 },
          { column: 10, width: 40 },
          { column: 11, width: 40 },
          { column: 12, width: 40 },
          { column: 13, width: 40 },
          { column: 14, width: 40 },
          { column: 15, width: 40 },
          { column: 16, width: 40 },
          { column: 17, width: 40 },
          { column: 18, width: 40 },
          { column: 19, width: 40 },
          { column: 20, width: 40 },
          { column: 21, width: 40 },
          { column: 22, width: 40 },
          { column: 23, width: 40 },
          { column: 24, width: 40 },
          { column: 25, width: 40 },
          { column: 26, width: 40 },
          { column: 27, width: 40 },
          { column: 28, width: 40 },
          { column: 29, width: 40 },
          { column: 30, width: 40 },
          { column: 31, width: 40 },
          { column: 32, width: 40 },
          { column: 33, width: 55 },
        ],
        wordWrap: "break-word",
        highlight: { column: [-1], row: [-1] },
        highlightedColor: colors[6],
      },
      departments: [],
      seletedDepartment: null,
      average: null,
      activeDays: 0,
      averagePerDay: null,
    };
  },
  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
  },
  methods: {
    tableCellClicked() {},
    resetUi() {
      this.params.data = [
        [
          "n",
          "Ime i prezime",
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16",
          "17",
          "18",
          "19",
          "20",
          "21",
          "22",
          "23",
          "24",
          "25",
          "26",
          "27",
          "28",
          "29",
          "30",
          "31",
          "Σ",
        ],
      ];
      this.dailyLogs = [];
    },
    monthChosen(mnth) {
      console.log(mnth);
      this.mnth = mnth;
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
      this.getDepartments();
    },
    getDepartments() {
      ReportService.GetAllDepartmentsOfMyCompanyHistoricallyByMonth(
        this.selectedMonth,
        this.selectedYear
      ).then((response) => {
        // UserService.getDepartments().then((response) => {
        // reset ui
        this.departments = [];
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    getData(departmentId, month, year) {
      console.log("getData");
      ReportService.GetDailyLogsByDepartmentIdAndMonth(
        departmentId,
        month,
        year
      ).then((response) => {
        console.log(response.data);
        this.calculateData(response.data);
        this.pushData();
      });
    },
    calculateData(data) {
      this.activeDays = 0;
      // first add days array to employees
      this.employees.forEach((emp) => {
        emp.days = new Array(31).fill(0);
        emp.total = 0;
      });
      data.forEach((dlog) => {
        // who I belong to?
        let emplyoee = this.employees.find(
          (e) => e.employeeId === dlog.employeeId
        );
        if (emplyoee) {
          // what day is it?
          let day = new Date(dlog.logDate).getDate();
          let late = dlog.overtimeWorkhours;
          if (dlog.overtimeWorkhours) {
            emplyoee.total += dlog.overtimeWorkhours;
          }
          // populate days
          emplyoee.days[day - 1] = late;
        } else {
          console.log("Nonexisting employee: ", dlog.employeeId);
        }
      });
    },
    pushData() {
      let ndx = 1;

      let totalValue = new Array(31).fill(0);

      this.employees.forEach((emp) => {
        totalValue[0] += emp.days[0];
        totalValue[1] += emp.days[1];
        totalValue[2] += emp.days[2];
        totalValue[3] += emp.days[3];
        totalValue[4] += emp.days[4];
        totalValue[5] += emp.days[5];
        totalValue[6] += emp.days[6];
        totalValue[7] += emp.days[7];
        totalValue[8] += emp.days[8];
        totalValue[9] += emp.days[9];
        totalValue[10] += emp.days[10];
        totalValue[11] += emp.days[11];
        totalValue[12] += emp.days[12];
        totalValue[13] += emp.days[13];
        totalValue[14] += emp.days[14];
        totalValue[15] += emp.days[15];
        totalValue[16] += emp.days[16];
        totalValue[17] += emp.days[17];
        totalValue[18] += emp.days[18];
        totalValue[19] += emp.days[19];
        totalValue[20] += emp.days[20];
        totalValue[21] += emp.days[21];
        totalValue[22] += emp.days[22];
        totalValue[23] += emp.days[23];
        totalValue[24] += emp.days[24];
        totalValue[25] += emp.days[25];
        totalValue[26] += emp.days[26];
        totalValue[27] += emp.days[27];
        totalValue[28] += emp.days[28];
        totalValue[29] += emp.days[29];
        totalValue[30] += emp.days[30];

        this.params.data.push([
          ndx++,
          emp.firstName + " " + emp.lastName,
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[0]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[1]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[2]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[3]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[4]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[5]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[6]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[7]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[8]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[9]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[10]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[11]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[12]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[13]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[14]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[15]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[16]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[17]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[18]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[19]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[20]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[21]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[22]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[23]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[24]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[25]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[26]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[27]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[28]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[29]), "00:00"),
          maskIfEquealsValue(getShortTimeFromTicks(emp.days[30]), "00:00"),
          maskIfEquealsValue(getDateFromTicks(emp.total), "00:00:00"),
        ]);
      });

      this.params.data.push([
        "",
        "Σ (za vremenski raspon)",
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[0]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[1]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[2]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[3]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[4]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[5]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[6]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[7]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[8]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[9]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[10]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[11]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[12]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[13]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[14]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[15]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[16]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[17]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[18]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[19]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[20]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[21]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[22]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[23]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[24]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[25]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[26]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[27]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[28]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[29]), "00:00"),
        maskIfEquealsValue(getShortTimeFromTicks(totalValue[30]), "00:00"),
        maskIfEquealsValue(
          getDateFromTicks(
            totalValue.reduce((partialSum, a) => partialSum + a, 0)
          )
        ),
      ]);

      this.average = getShortTimeFromTicks(
        Math.floor(
          totalValue.reduce((partialSum, a) => partialSum + a, 0) / (ndx - 1)
        )
      );
      this.averagePerDay = getShortTimeFromTicks(
        Math.floor(
          totalValue.reduce((partialSum, a) => partialSum + a, 0) /
            (ndx - 1) /
            this.activeDays
        )
      );
    },
    departmentSelected() {
      this.resetUi();

      let departmentId = this.seletedDepartment.id;

      let allEmployees = this.departmentData.find((d) => {
        return d.departmentId === departmentId;
      }).employee;

      this.employees = [];
      allEmployees.forEach((emp) => {
        // uvažiti i radnike čiji status je false ali su taj mjesec radili.
        console.log("w");
        console.log(emp.endDate);
        console.log(emp.firstName);
        console.log(new Date(emp.endDate));
        console.log(this.mnth);
        console.log(new Date(emp.startDate));
        console.log(getLastDateOfMonth(this.selectedMonth, this.selectedYear));
        console.log(
          new Date(emp.startDate) <
            getLastDateOfMonth(this.selectedMonth, this.selectedYear)
        );
        if (shouldEmployeeBeAdded(emp, this.selectedMonth, this.selectedYear)) {
          this.employees.push(emp);
        }
      });

      this.getData(departmentId, this.selectedMonth, this.selectedYear);
    },
  },
};
</script>

<style scoped>
.base-demo {
  width: 1550px;
  white-space: nowrap;
}

.small {
  font-size: 10px;
}

.base-demo >>> .v-table-row.is-header {
  /* background: red !important; */
  /* border-top: 1px solid red !important; */
  /* border-right: 1px solid red !important; */
  border-bottom: 1px solid red !important;
}
.base-demo >>> .table-cell {
  /* border-left: 1px solid red !important; */
  padding: 1px !important;
  /* flex: 0 0 30px !important; */
}
.base-demo >>> .table-cell-content {
  /* border-left: 1px solid red !important; */
  /* margin: 0px -10px 0px -10px !important; */
  padding: 0px !important;
  /* flex: 0 0 0 0px !important; */
}
</style>
